import React from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { HowItWorksStrip } from '../components/HowItWorksStrip';
import { ProblemSection } from '../components/ProblemSection';
import { AddExpenses } from '../components/AddExpenses';
import { WhoOwesWhom } from '../components/WhoOwesWhom';
import { WhyKittyPot } from '../components/WhyKittyPot';
import { WaysToJoin } from '../components/WaysToJoin';
import { CreateKitty } from '../components/CreateKitty';
import { MyBalance } from '../components/MyBalance';
import { SettleUp } from '../components/SettleUp';
import { HistorySection } from '../components/HistorySection';
import { RoundSpinner } from '../components/RoundSpinner';
import { UseCases } from '../components/UseCases';
import { SocialProof } from '../components/SocialProof';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-568" data-mp="30up09zqtaace">
      <SEO title="KittyPot | Split the cost. Not the friendship." description="One place for every group expense, so nobody has to remember who paid, chase their mates or argue over the maths. Friends can join without the app. Free on Google Play." ogTitle="KittyPot | Split the cost. Not the friendship." ogDescription="One place for every group expense. Add what you spend, see who owes whom, and settle up directly. Friends can join without the app." path="/" jsonLd={[{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'KittyPot',
      url: 'https://www.kittypot.com',
      description: 'KittyPot is a shared expense tracker for friends, trips and housemates. Create a kitty, track who paid what, see who owes what, and settle up directly with each other. KittyPot does not hold or move money.'
    }, {
      '@context': 'https://schema.org',
      '@type': 'MobileApplication',
      name: 'KittyPot',
      applicationCategory: 'FinanceApplication',
      operatingSystem: 'Android',
      url: 'https://www.kittypot.com',
      installUrl: 'https://play.google.com/store/apps/details?id=com.kittypot.app',
      description: 'Track group expenses, see who owes whom, and settle up directly. Friends can join a kitty from their browser without installing the app.',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'GBP'
      },
      publisher: {
        '@type': 'Organization',
        name: 'KittyPot Ltd',
        url: 'https://www.kittypot.com'
      }
    }]} data-id="element-569" data-mp="2vvvp4dyzyvfe" />
      <Navbar data-id="element-570" data-mp="flaidhzgj81o" />
      <main data-id="element-571" data-mp="fksebz6jzpj7">
        {/* Promise, then the mechanism, in the first two screens. */}
        <HeroSection data-id="element-572" data-mp="an9214tf1mtw" />
        <HowItWorksStrip data-id="element-573" data-mp="alxxv3w26d29" />

        {/* The pain, then the payoff, before any feature detail. */}
        <ProblemSection data-id="element-574" data-mp="od2sfrkkkf5q" />
        <AddExpenses data-id="element-575" data-mp="odcex56eo46o" />
        <WhoOwesWhom data-id="element-576" data-mp="kcitcigfr1gy" />

        {/* Why us, and the thing competitors do not do. */}
        <WhyKittyPot data-id="element-577" data-mp="ken51mkkt4rs" />
        <WaysToJoin data-id="element-578" data-mp="3ss2ip6dzjzqq" />

        {/* Supporting detail for anyone still reading. */}
        <CreateKitty data-id="element-579" data-mp="3su6v6cpya72m" />
        <MyBalance data-id="element-580" data-mp="3ntiybaf1iw0h" />
        <SettleUp data-id="element-581" data-mp="3nuaryfp2ujo4" />
        <HistorySection data-id="element-582" data-mp="3nutyz1d6vnnd" />
        <RoundSpinner data-id="element-583" data-mp="3nvc0odimeu2o" />

        {/* Who it is for, then the ask. */}
        <UseCases data-id="element-584" data-mp="5ofppfpv81vb" />
        <SocialProof data-id="element-585" data-mp="5ljnvgawct1l" />
        <Pricing data-id="element-586" data-mp="ojiz8ps9wc2" />
        <FinalCTA data-id="element-587" data-mp="o1n4d719k4o" />
      </main>
      <Footer data-id="element-588" data-mp="nrz2v5jtn1m" />
    </div>;
}